module.exports = __webpack_public_path__ + "static/media/hyperpay.086e2504.png";